<template>
    <rect x="25" y="20" width="100" height="60" rx="10" ry="10" stroke="none"/>
</template>